import React from "react"
import "../styles/team.scss"
import MainLayout from "../layouts/MainLayout"
import { Heading1 } from "../components/utils/Typography"
import Breadcrumb from "../components/utils/Breadcrumb"
import { TEAM_LIST } from "../data"
import "../styles/global.scss"

function Team() {
  return (
    <div className="team">
      <MainLayout>
        <Breadcrumb
          arr={[
            { name: "Home", path: "/" },
            { name: "Team", path: "/team" },
          ]}
        />
        <Heading1
          heading="Team"
          subheading="dedicated team, expert developers"
        />
        <div className="container mt-4 pt-3">
          <div className="row justify-content-evenly">
            {TEAM_LIST.map((i, ind) => (
              <div className="py-5 py-md-3  col-12 col-md-4" key={ind}>
                <div className="teamCard row">
                  <div className="col-12 d-flex justify-content-center align-items-center personImg pb-2">
                    <img
                      src={i.img}
                      alt=""
                      className="img-fluid"
                      width="220px"
                    />
                  </div>
                  <div className="col-12 text-center d-flex justify-content-center align-items-center heading">
                    <div className="fs-4">{i.name}</div>
                  </div>
                  <div className="col-12 text-center d-flex justify-content-center align-items-center">
                    <div className="fs-6">{i.role}</div>
                  </div>
                  <div className="col-12 text-center d-flex justify-content-center align-items-center pt-3">
                    {i.linkedin && (
                      <a
                        href={i.linkedin}
                        target="_blank"
                        rel="noreferrer"
                        className="fs-3 mx-3 "
                      >
                        <i className="bi bi-linkedin"></i>
                      </a>
                    )}
                    {i.github && (
                      <a
                        href={i.github}
                        target="_blank"
                        rel="noreferrer"
                        className="fs-3 mx-3 "
                      >
                        <i className="bi bi-github"></i>
                      </a>
                    )}
                    {i.facebook && (
                      <a
                        href={i.facebook}
                        target="_blank"
                        rel="noreferrer"
                        className="fs-3 mx-3 "
                      >
                        <i className="bi bi-facebook"></i>
                      </a>
                    )}
                    {i.mail && (
                      <a
                        href={`mailto:${i.mail}`}
                        target="_blank"
                        rel="noreferrer"
                        className="fs-3 mx-3 "
                      >
                        <i className="bi bi-envelope-fill"></i>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </MainLayout>
    </div>
  )
}

export default Team
